import MontuMarkdown from "@repo/components/src/shared/markdown";
import { Box } from "@repo/components/src/ui/box";
import { Text } from "@repo/components/src/ui/text";
import React from "react";
import SectionHeader from "./SectionHeader";

type Props = {
  description: string;
};

/** Ported from `apps/mobil/.../about/BriefCard.tsx`. */
const AboutSection = React.memo(({ description }: Props) => (
  <>
    <SectionHeader title="Sobre la campaña" />
    <Box className="rounded-3xl bg-white border border-outline-100 px-4 py-4">
      {description.trim() ? (
        <MontuMarkdown baseSize={14}>{description}</MontuMarkdown>
      ) : (
        <Text size="sm" action="muted">
          Aún no se ha escrito una descripción.
        </Text>
      )}
    </Box>
  </>
));

AboutSection.displayName = "AboutSection";

export default AboutSection;
